import { render, staticRenderFns } from "./PlayersRegion.vue?vue&type=template&id=9e0275d0&"
import script from "./PlayersRegion.vue?vue&type=script&lang=js&"
export * from "./PlayersRegion.vue?vue&type=script&lang=js&"
import style0 from "./PlayersRegion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports